import { useMutation } from "@tanstack/react-query";

import { profileApi } from "@/features/profile/services/profile.api";

/**
 * Deliberately does *not* auto-clear local auth state on settle (unlike
 * `useLogout`'s otherwise-identical shape) — `SettingsPage` is a
 * `RequireAuth`-protected route, and clearing credentials while still
 * mounted there races that guard's own redirect-to-login against this
 * mutation's caller navigating to home, with no guaranteed winner. The
 * caller navigates away *first*, then clears local state once the mutation
 * actually resolves — by which point the client-side transition off this
 * page has long since finished, so there's nothing left to race.
 */
export function useDeleteAccount() {
  return useMutation({
    mutationFn: profileApi.deleteAccount,
  });
}
